export function sellerAdvisoryResidentialCP826() {
return [   // Release 2026-09-02 12:06:15
 
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 151.8,
   width: 393.6,
   height: 10.08
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.619,
   left: 169.692,
   width: 373.201,
   height: 14.145
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 181.764,
   left: 169.692,
   width: 373.201,
   height: 14.146
}
,
{
   page: 0,
   name: "Seller Broker and CoAgent Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 208.255,
   left: 169.692,
   width: 373.201,
   height: 14.146
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 235.092,
   left: 169.692,
   width: 373.201,
   height: 14.145
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 151.8,
   width: 393.6,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 151.8,
   width: 393.6,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 151.8,
   width: 393.6,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 151.8,
   width: 393.6,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 47.4,
   left: 151.8,
   width: 393.6,
   height: 11.16
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 763.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 5,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 550.13,
   left: 71.3458,
   width: 378.4372,
   height: 15.455
}
,
{
   page: 5,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 548.821,
   left: 460.802,
   width: 72.763,
   height: 16.764
}
,
{
   page: 5,
   name: "Signature Seller CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 586.821,
   left: 71.3458,
   width: 382.3642,
   height: 16.109
}
,
{
   page: 5,
   name: "Date Signature Seller CoAgent", 
   fontSize: 9,
   type: "date",
   top: 586.584,
   left: 460.802,
   width: 72.763,
   height: 16.764
}
] }
